'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var bumbag = require('bumbag');
var platform = require('platform');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var platform__default = /*#__PURE__*/_interopDefaultLegacy(platform);

var IncompatibleBrowserMessage = function IncompatibleBrowserMessage() {
  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2741): Property 'baseId' is missing in type '{ children: ... Remove this comment to see the full error message
    React__default["default"].createElement(bumbag.Callout.Overlay, {
      visible: platform__default["default"].name === 'IE',
      showCloseButton: true,
      title: "Incompatible browser",
      type: "danger"
    }, "The browser you are using is incompatible with Tyro Health. ", /*#__PURE__*/React__default["default"].createElement("br", null), "Please use", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "https://www.google.com/chrome/",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Chrome"), ",", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "https://www.mozilla.org/en-US/firefox/",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Firebox"), ",", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "https://www.apple.com/au/safari/",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Safari"), ",", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "https://www.opera.com/",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Opera"), ' ', "or", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "https://www.microsoft.com/en-au/windows/microsoft-edge",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "Edge"), ' ', "for the best viewing experience.")
  );
};

exports["default"] = IncompatibleBrowserMessage;
